import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

/**
 * SEO Component for managing meta tags
 * @param {string} page - The page identifier (e.g., 'home', 'impressum', 'datenschutz')
 * @param {string} customTitle - Optional custom title
 * @param {string} customDescription - Optional custom description
 */
function SEO({ page = 'home', customTitle, customDescription }) {
  const { t, i18n } = useTranslation()

  // Get translations for the specific page
  const title = customTitle || t(`seo.${page}.title`)
  const description = customDescription || t(`seo.${page}.description`)
  const keywords = t(`seo.${page}.keywords`, '')
  const siteName = t('seo.siteName')
  const author = t('seo.author')

  // Determine locale for Open Graph
  const locale = i18n.language === 'de' ? 'de_DE' : 'en_US'
  const alternateLocale = i18n.language === 'de' ? 'en_US' : 'de_DE'

  // Base URL - should be replaced with actual domain in production
  const baseUrl = window.location.origin
  const currentUrl = window.location.href

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang={i18n.language} />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${baseUrl}/og-image.png`} />
      <meta property="og:locale" content={locale} />
      <meta property="og:locale:alternate" content={alternateLocale} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${baseUrl}/twitter-image.png`} />
    </Helmet>
  )
}

export default SEO
